import { computed, ref, watch } from "vue";

export function useTablePagination({ items, page = 1, perPage = 10, resetDeps = [] }) {
    const currentPage = ref(page);
    const itemsPerPage = ref(perPage);

    // ---------- PAGINATED ITEMS ----------
    const paginatedItems = computed(() => {
        if (!Array.isArray(items.value)) return [];

        const start = (currentPage.value - 1) * itemsPerPage.value;
        const end = start + itemsPerPage.value;

        return items.value.slice(start, end);
    });

    // ---------- TOTAL INFO ----------
    const totalInfo = computed(() => {
        const totalItems = items.value?.length || 0;

        return {
            totalItems,
            totalPages: Math.ceil(totalItems / itemsPerPage.value),
            limit: itemsPerPage.value,
            page: currentPage.value,
        };
    });

    // ---------- PAGE CHANGE ----------
    function onPageChange(page) {
        if (!page) return;
        currentPage.value = page;
    }

    // ---------- RESET PAGE ----------
    if (Array.isArray(resetDeps)) {
        watch(resetDeps, () => {
            currentPage.value = 1;
        });
    }

    return {
        currentPage,
        itemsPerPage,
        paginatedItems,
        totalInfo,
        onPageChange
    };
}
